import Scroller from "../util/scroller";
import MoveIt from "../util/moveit";
import Filters from "../components/filter";
var Flickity = require("flickity");


export default {
    init() {
        this.Filters = new Filters();
        var recipes = {
                list_item: document.querySelectorAll(".list-item--recipe"),
                scroller: [],
                callback: function () {
                    this.classList.add("is-visible");
                }
            },
            i = 0,
            moveit = new MoveIt();

        for (i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new Scroller(recipes.list_item[i], {
                callback: recipes.callback,
                once: true
            });
        };

        var banner = new Flickity(".banner ul", {
            cellAlign: "left",
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 50,
                x3: 60
            },
            pageDots: false
        });
    },
    finalize() {

    }
};



// WEBPACK FOOTER //
// ./js/routes/tax-recipe_category.js